export const COVERAGE_PRIORITY_OPTIONS = [
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
] as const;

export type CoveragePriority = (typeof COVERAGE_PRIORITY_OPTIONS)[number]['value'];

export const formatCoveragePriority = (value?: string | null): string => {
  if (!value) return '—';
  const normalized = value.trim().toLowerCase();
  const match = COVERAGE_PRIORITY_OPTIONS.find((option) => option.value === normalized);
  return match?.label ?? value;
};
